import { Map } from 'immutable';
import { actionTypes } from '../../../../controller';

const {
	SET_QUOTATION,
	RESET_QUOTATION,
} = actionTypes;
const initialState = Map({
	data: Map(),
});

export default function quotation(state = initialState, action) {
	switch (action.type) {
		case SET_QUOTATION: {
			return state.set('data', Map(action.quotation));
		}

		case RESET_QUOTATION: {
			return state.set('data', Map());
		}

		default:
			return state;
	}
}
